import React from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from '../../translations'
import * as routeHandlers from './route_groups'
import './nav.css'

const iconColor = '#484848'

const IconNav = (props) => {
  const { t, width, user, pathname, selectedPage } = props

  const superAdmin = user.get('superAdmin')
  const qcAdmin = user.get('qcAdmin')
  const facilityAdmin = user.get('facilityAdmin')
  const coach = user.get('coach')
  // const enterpriseAccess = user.get('enterpriseRole');
  const hasFacilityAccess = (superAdmin || facilityAdmin || coach) && !qcAdmin

  return (
    <div className="iconav-slider">
      <ul className="nav-pills iconav-nav flex-md-column p-0 custom-nav-pills">
        {/* {
          enterpriseAccess && (

            <li
              className='nav-item'
              onClick={ () => props.updateSelected(routeHandlers.ENTERPRISE) }
              style={ (selectedPage === routeHandlers.ENTERPRISE || (!selectedPage && routeHandlers.fetchRouteGroup(pathname) === routeHandlers.ENTERPRISE)) ? { background: '#e5ebf1' } : null }>
              <a className='nav-link' style={ { padding: '10px', borderLeft: 'none' } }>
                <span className='fas fa-building' style={ { color: iconColor } } />
                <small className='iconav-nav-label d-md-none'>Enterprise</small>
              </a>
            </li>
          )
        } */}
        {superAdmin && (
          <li
            className="nav-item"
            onClick={() => props.updateSelected(routeHandlers.FIT3D_ADMIN)}
            style={
              selectedPage === routeHandlers.FIT3D_ADMIN ||
              (!selectedPage &&
                routeHandlers.fetchRouteGroup(pathname) ===
                  routeHandlers.FIT3D_ADMIN)
                ? { background: '#e5ebf1' }
                : null
            }
          >
            <a
              className="nav-link"
              style={{ padding: '10px', borderLeft: 'none' }}
            >
              <span className="fas fa-cogs" style={{ color: iconColor }} />
              <small className="iconav-nav-label d-md-none">
                {t('nav.admin')}
              </small>
            </a>
          </li>
        )}
        {hasFacilityAccess && (
          <li
            className="nav-item"
            onClick={() => props.updateSelected(routeHandlers.FACILITY)}
            style={
              selectedPage === routeHandlers.FACILITY ||
              (!selectedPage &&
                routeHandlers.fetchRouteGroup(pathname) ===
                  routeHandlers.FACILITY)
                ? { background: '#e5ebf1' }
                : null
            }
          >
            <a
              className="nav-link"
              style={{ padding: '10px', borderLeft: 'none' }}
            >
              <span className="fas fa-users" style={{ color: iconColor }} />
              <small className="iconav-nav-label d-md-none">
                {t('nav.facility')}
              </small>
            </a>
          </li>
        )}
        <li
          className="nav-item"
          onClick={() => props.updateSelected(routeHandlers.FITNESS)}
          style={
            selectedPage === routeHandlers.FITNESS ||
            (!selectedPage &&
              routeHandlers.fetchRouteGroup(pathname) === routeHandlers.FITNESS)
              ? { background: '#e5ebf1' }
              : null
          }
        >
          <a
            className="nav-link"
            style={{ padding: '10px', borderLeft: 'none' }}
          >
            <span className="fas fa-heartbeat" style={{ color: iconColor }} />
            <small className="iconav-nav-label d-md-none">
              {t('nav.fitness')}
            </small>
          </a>
        </li>
        <li
          className="nav-item"
          onClick={() => {
            props.updateSelected(routeHandlers.HISTORY)
            if (width <= 768) props.redirectPage('/history')()
          }}
          style={
            selectedPage === routeHandlers.HISTORY ||
            (!selectedPage &&
              routeHandlers.fetchRouteGroup(pathname) === routeHandlers.HISTORY)
              ? { background: '#e5ebf1' }
              : null
          }
        >
          <a
            className="nav-link"
            style={{ padding: '10px', borderLeft: 'none' }}
          >
            <span className="fas fa-list-ul" style={{ color: iconColor }} />
            <small className="iconav-nav-label d-md-none">
              {t('nav.history')}
            </small>
          </a>
        </li>
        <li
          className="nav-item"
          onClick={() => props.updateSelected(routeHandlers.ACCOUNT)}
          style={
            selectedPage === routeHandlers.ACCOUNT ||
            (!selectedPage &&
              routeHandlers.fetchRouteGroup(pathname) === routeHandlers.ACCOUNT)
              ? { background: '#e5ebf1' }
              : null
          }
        >
          <a
            className="nav-link"
            style={{ padding: '10px', borderLeft: 'none' }}
          >
            <span className="fas fa-user-circle" style={{ color: iconColor }} />
            <small className="iconav-nav-label d-md-none">
              {t('nav.account')}
            </small>
          </a>
        </li>
      </ul>
    </div>
  )
}

IconNav.propTypes = {
  width: PropTypes.number,
  selectedPage: PropTypes.string,
  user: PropTypes.object.isRequired,
  redirectPage: PropTypes.func,
  updateSelected: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default withTranslation(IconNav)
